import CardAnalise from '@componentsNew/Analises/CardAnalises';
import ListaAnalises from '../../ListaAnalises';

function AnaliseSeoEstrutura({ analise, carregando, erro }) {
  return (
    <CardAnalise
      nota={analise?.filter(r => r.otimizado == true).length / analise?.length}
      titulo="Análise de SEO"
      subTitulo="Critérios estruturais"
    >
      <ListaAnalises
        resultadoAnalises={analise}
        carregando={carregando}
        erro={erro}
        tipo={'nao_textual'}
        botaoDeslizar={false}
      />
    </CardAnalise>
  );
}

export default AnaliseSeoEstrutura;
